class ProjectsService {
  constructor(apiService, reportsService) {
    this.apiService = apiService;
    this.reportsService = reportsService;
  }

  getLanguages() {
    return this.apiService.get('/api/v1/one/languages');
  }

  translateMessage(params) {
    return this.apiService.post('/api/v1/one/translate', params);
  }

  getTemplates() {
    return this.apiService.get('/api/v1/one/project-templates');
  }

  getFormTemplatesPage(params) {
    return this.apiService.get('/api/v1/one/project-templates/page', params);
  }

  getTemplateById(id) {
    return this.apiService.get(`/api/v1/one/project-templates/${id}`);
  }

  async createFormTemplate(params) {
    const { payload, one } = this.reportsService.mapTemplatePayload(params, true);
    const { id } = await this.apiService.post('/api/v1/one/project-templates', payload);
    if (one) {
      const upload = async (g, type) => {
        const p = new FormData();
        p.append('type', type);
        p.append('file', g.file);
        p.append('key', g.id);
        await this.apiService.put(`/api/v1/one/project-templates/${id}/file`, p, { headers: { 'Content-Type': 'multipart/form-data' } });
      };
      for (const key in one.groups) {
        const g = one.groups[key];
        await upload(g, 'group');
      }
      for (const key in one.fields) {
        const g = one.fields[key];
        await upload(g, 'field');
      }
    }
  }

  async updateFormTemplate(params, id) {
    const { payload, one } = this.reportsService.mapTemplatePayload(params, true);
    await this.apiService.put(`/api/v1/one/project-templates/${id}`, payload);

    if (one) {
      const upload = async (g, type) => {
        if (g.file && typeof g.file === 'string') {
          return;
        }
        const p = new FormData();
        p.append('type', type);
        p.append('file', g.file);
        p.append('key', g.id);
        await this.apiService.put(`/api/v1/one/project-templates/${id}/file`, p, { headers: { 'Content-Type': 'multipart/form-data' } });
      };
      for (const key in one.groups) {
        const g = one.groups[key];
        await upload(g, 'group');
      }
      for (const key in one.fields) {
        const g = one.fields[key];
        await upload(g, 'field');
      }
    }
  }

  deleteTemplates(params) {
    return this.apiService.delete('/api/v1/one/project-templates', params);
  }
}

export default ProjectsService;
